import { render, staticRenderFns } from "./Detail-SubPart.vue?vue&type=template&id=0c9c5ba7"
import script from "./Detail-SubPart.vue?vue&type=script&lang=js"
export * from "./Detail-SubPart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports